class ProductMediaButton extends HTMLElement {
  swiperElement = this.closest('[data-swiper]') || null;
  swiperInstance = this.swiperElement?.swiper || null;
  button = this.querySelector('button');
  controller = new AbortController();

  connectedCallback() {
    if (!this.swiperElement || !this.button) return;
    this.button.addEventListener(
      'click',
      () => {
        this.button.dataset.direction === 'prev'
          ? this.swiperInstance.slidePrev()
          : this.swiperInstance.slideNext();
      },
      { signal: this.controller.signal }
    );
  }

  disconnectedCallback() {
    this.controller.abort();
  }
}

customElements.define('product-media-button', ProductMediaButton);
